<div class="loyalty-personal-information-form form-container service-form">
  <div #fcomNotification aria-live="polite">
    <fcom-notification
      *ngIf="formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR"
      class="pr-small-y pr-clear-t mr-clear block"
      [theme]="formStatus === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
      [iconName]="formStatus === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
    >
      {{
        (formStatus === FormStatus.ERROR ? 'SERVICE_FORMS.serviceForms.error.title' : 'plus.profile.updateSuccess')
          | finLocalization
      }}
    </fcom-notification>
  </div>
  <span class="block pr-medium-b font-body-1 nordic-blue-900-text">{{
    'SERVICE_FORMS.serviceForms.mandatoryFields' | finLocalization
  }}</span>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
  <div class="flex personal-information" *ngIf="formStatus !== FormStatus.LOADING" data-hj-suppress>
    <div class="flex-1 ms-medium-b">
      <div class="font-body-1 bold-type">{{ name }}</div>
      <div *ngIf="dateOfBirth && profileTier !== ProfileTier.ACCOUNT">
        {{ 'SERVICE_FORMS.serviceForms.fields.dateOfBirth.label' | finLocalization }}:
        {{ dateOfBirth | finDateFormat: 'DATE' }}
      </div>
    </div>
    <div class="flex-1 ms-medium-b" *ngIf="profileTier !== ProfileTier.ACCOUNT">
      <div class="font-body-1 bold-type">
        {{ 'SERVICE_FORMS.serviceForms.fields.membershipNumber' | finLocalization }}
      </div>
      <div>{{ memberNumber }}</div>
    </div>
  </div>
  <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" [finFormErrorFocus]="reactiveForm">
    <div *ngIf="formStatus !== FormStatus.LOADING">
      <fin-datepicker
        *ngIf="profileTier === ProfileTier.ACCOUNT || !dateOfBirth"
        [parentForm]="reactiveForm"
        [controlName]="'dateOfBirth'"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.dateOfBirth'"
        [placeHolder]="'SERVICE_FORMS.serviceForms.fields.dateOfBirth.placeholder'"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [icon]="SvgLibraryIcon.CALENDAR"
      ></fin-datepicker>
      <div class="input-wrapper">
        <fin-form-input-text
          [parentForm]="reactiveForm"
          [controlName]="'email'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.email'"
        ></fin-form-input-text>
        <button
          type="button"
          class="icon"
          fcomPopover
          [options]="tooltipOptions"
          [content]="contentTooltip"
          [ariaCloseText]="'SERVICE_FORMS.serviceForms.fields.email.tooltip.ariaClose' | finLocalization"
          [attr.aria-label]="'SERVICE_FORMS.serviceForms.fields.email.tooltip.heading' | finLocalization"
        >
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.HELP_BLOCK"></fcom-icon>
        </button>
      </div>
      <div class="flex personal-information" data-hj-suppress>
        <fin-form-input-select
          class="pr-medium-r"
          [parentForm]="reactiveForm"
          [controlName]="'countryCode'"
          [options]="phonePrefixes$ | async"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.phonePrefix'"
        ></fin-form-input-select>
        <fin-form-input-text
          class="flex-1"
          [parentForm]="reactiveForm"
          [controlName]="'nationalNumber'"
          [placeHolder]="'SERVICE_FORMS.serviceForms.fields.phoneNumber.placeholder'"
          [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.phoneNumber'"
        ></fin-form-input-text>
      </div>
      <fcom-radio-item-group
        class="ps-large-r"
        [options]="genders"
        [parentForm]="reactiveForm"
        [controlName]="'gender'"
        [isRequired]="true"
        [translationPrefix]="'SERVICE_FORMS.serviceForms.fields.gender'"
      >
      </fcom-radio-item-group>
    </div>
    <div class="ps-small-t mr-xxsmall-r flex flex--space-between">
      <a
        class="nordic-blue-900-text bold-type no-underline pr-xxsmall-t font-body-1 link-hover"
        [attr.href]="changePasswordUrl"
      >
        <span class="underline">
          {{ 'SERVICE_FORMS.serviceForms.fields.changePassword' | finLocalization }}
        </span>
        <span class="cta" aria-hidden="true">
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT"></fcom-icon>
        </span>
      </a>
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.save' | finLocalization"
      ></fcom-button>
    </div>
  </form>
</div>

<ng-template #contentTooltip>
  <h2 class="font-body-1 bold-type nordic-blue-900-text">
    {{ 'SERVICE_FORMS.serviceForms.fields.email.tooltip.heading' | finLocalization }}
  </h2>
  <p class="pr-xxsmall-t">{{ 'SERVICE_FORMS.serviceForms.fields.email.tooltip.content' | finLocalization }}</p>
</ng-template>
